module.exports = __webpack_public_path__ + "static/media/solution-tube-a_--closed.7938fa41.svg";